import React from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import Label from "../Steuerelemente/Label.jsx";
import ToggleButton from "../Steuerelemente/ToggleButton.jsx";
import Datafield from "../Steuerelemente/Datafield.jsx";

const AnalogOutElement = observer((props) => {
  const name = props.name;
  const { manAuto, manValue, anaOut, hardw } = props.data;

  //========================================================================
  // Rectangle
  const rectangleStyle = {
    position: "relative",
    left: `calc(${globalVars.scaleFactor} * 10px)`,
    width: `calc(100% - (${globalVars.scaleFactor} * 30px))`,
    height: `calc(${globalVars.scaleFactor} * 40px)`,
    backgroundColor: "rgba(83, 83, 83)",
    borderRadius: `calc(${globalVars.scaleFactor} * 5px)`,
    borderStyle: "none",
    borderWidth: "0px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0",
    paddingLeft: `calc(${globalVars.scaleFactor} * 10px)`,
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  //========================================================================
  // Label Style
  const labelStyle = {
    width: `calc(${globalVars.scaleFactor} * 605px)`,
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontSize: `calc(${globalVars.scaleFactor} * ${props.style.textFontSize})`,
    color: "#D4CBCB",
    textAlign: "left",
  };

  //========================================================================
  // Button Style
  const buttonStyle = {
    position: "absolute",
    right: `calc(${globalVars.scaleFactor} * 350px)`,
    width: `calc(${globalVars.scaleFactor} * 80px)`,
    height: `calc(${globalVars.scaleFactor} * 30px)`,
    backgroundColor: "#000000",
    borderRadius: `calc(${globalVars.scaleFactor} * 5px)`,
    borderStyle: "none",
    fontSize: `calc(${globalVars.scaleFactor} * 12px)`,
    color: "white",
    textAlign: "center",
    lineHeight: `calc(${globalVars.scaleFactor} * 30px)`,
  };

  //========================================================================
  // Datafield Style
  const datafieldStyle = {
    position: "absolute",
    width: `calc(${globalVars.scaleFactor} * 100px)`,
    height: `calc(${globalVars.scaleFactor} * 25px)`,
    fontSize: `calc(${globalVars.scaleFactor} * 14px)`,
    color: "white",
    textHorizontalAlignment: "center",
    textVerticalAlignment: "center",
    borderStyle: "solid",
    borderWidth: `calc(${globalVars.scaleFactor} * 1px)`,
    borderColor: "black",
  };

  const datafieldAoStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 235px)`,
    backgroundColor: "#2A3845",
  };

  const datafieldManValueStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 120px)`,
    backgroundColor: "#13A16B",
  };

  const datafieldHardwStyle = {
    ...datafieldStyle,
    right: `calc(${globalVars.scaleFactor} * 5px)`,
    backgroundColor: "#2A3845",
  };

  return (
    <div style={{ height: `calc(${globalVars.scaleFactor} * 40px)` }}>
      <div style={rectangleStyle}>
        <Label
          style={labelStyle}
          element={null}
          props={{ text: name, visibility: "visible" }}
        />
        <ToggleButton
          style={buttonStyle}
          element={{ activeColor: "#02B032" }}
          props={{
            variable: manAuto,
            visibility: "visible",
            text: ["Hand/Auto", "", ""],
          }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldAoStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: anaOut, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldManValueStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: manValue, visibility: "visible" }}
          authWrite={props.authWrite}
        />
        <Datafield
          style={datafieldHardwStyle}
          element={{
            textHorizontalAlignment: "center",
            textVerticalAlignment: "center",
          }}
          props={{ variable: hardw, visibility: "visible" }}
          authWrite={props.authWrite}
        />
      </div>
    </div>
  );
});

export default AnalogOutElement;
